import { DatepickerController } from "./DatepickerController";
import { SessionService } from "../../services";

/**
 * Controller for datepicker popup control.
 */
export class DatepickerPopupController extends DatepickerController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService", "$element", "$timeout", "$scope"];

  /** Date format in text input. Default is d.M.yyyy */
  public format: string;

  constructor(sessionService: SessionService, $element: JQLite, $timeout: ng.ITimeoutService, $scope: ng.IScope) {
    super(sessionService, $element, $timeout, $scope);
  }

  /** Gets the tooltip HTML with necessary escape. */
  protected getToolTipHtml() {
    // TODO: Add escaping if necessary.
    return this.tooltipHtml;
  }
}